import React from 'react';
import Input from '@mui/material/Input';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';

interface Props {
    fuzzySearchTerm: string;
    onFuzzySearchChange: (term: string) => void;
}

const SearchTermFilter: React.FC<Props> = props => {
    const handleClear = () => {
        props.onFuzzySearchChange('');
    };

    return (
        <Input
            fullWidth
            value={props.fuzzySearchTerm}
            onChange={e => props.onFuzzySearchChange(e.target.value)}
            placeholder="Search"
            startAdornment={
                <InputAdornment position="start">
                    <SearchIcon />
                </InputAdornment>
            }
            endAdornment={
                props.fuzzySearchTerm && (
                    <InputAdornment position="end">
                        <IconButton onClick={handleClear}>
                            <ClearIcon fontSize={'small'} />
                        </IconButton>
                    </InputAdornment>
                )
            }
        />
    );
};

export default SearchTermFilter;
